import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TransactionRangeDialogComponent } from './transaction-range.dialog';

@Injectable({
  providedIn: 'root'
})
export class TransactionRangeDialogService {
  constructor(private dialog: MatDialog) {}

  open(dateRange?: { start: Date; end: Date }, receipt?: any, account?: string) {
    return this.dialog.open(TransactionRangeDialogComponent, {
      width: '1480px',
      maxWidth: '96vw',
      height: '88vh',
      autoFocus: false,
      data: {
        dateRange,
        receipt,
        account
      }
    });
  }
}
